import React from "react";
import {
  Box,
  Container,
  HStack,
  Stack,
  VStack,
  Heading,
  Text,
  Image,
} from "@chakra-ui/react";
import elipse1 from "../../assets/images/Ellipse9.png";
import elipse2 from "../../assets/images/Ellipse8.png";
import social1 from "../../assets/images/opensea 1.svg";
import social2 from "../../assets/images/Vector (4).svg";
import social3 from "../../assets/images/Vector (5).svg";
import social4 from "../../assets/images/Vector (6).svg";
import social5 from "../../assets/images/Vector (7).svg";

const team = [
  {
    logo: elipse1,
    name: "Marblemaster",
    position: "Game theory geek/software developer",
    telegram: "https://t.me/Dmitry_Forest",
    twitter: "https://twitter.com/Dmitry_Forest",
  },
  {
    logo: elipse2,
    name: "D. Forrest",
    position: "Art Designer/NFT expert",
    telegram: "https://t.me/Dmitry_Forest",
    twitter: "https://twitter.com/Dmitry_Forest",
  },
];

function index() {
  return (
    <Container maxW="container.xl" mb={32} w="100%" id="team">
      <Box w="100%">
        <VStack w="100%" spacing={16}>
          <Heading as="h2" size="xl" textShadow="0px 0px 50px #FFFFFF">
            MEET OUR TEAM
          </Heading>
          <Stack
            alignItems="center"
            direction={{ base: "column", md: "row" }}
            spacing={10}
          >
            {team.map(({ logo, name, position, telegram, twitter }, index) => (
              <Blocks
                key={index}
                logo={logo}
                name={name}
                position={position}
                telegram={telegram}
                twitter={twitter}
              />
            ))}
          </Stack>
          <Text
            backdropFilter="blur(5px) brightness(100%)"
            borderRadius="15px"
            bg="rgba(255, 255, 255, .15)"
            p={10}
            lineHeight="2"
          >
            Marbleverse is a four person team, passionate about bringing this
            project to life. Currently consisting of a project lead, NFT art
            designer, solidity and game developers. Our team strongly believes
            in the success of this project and its long-term potential.
            Information presented here is only the first step towards
            communicating our full vision, with lots of vital ideas still to be
            released in our socials.
          </Text>
        </VStack>
      </Box>
    </Container>
  );
}

const Blocks = ({ logo, name, position, telegram, twitter }) => {
  return (
    <Box w="100%">
      <VStack alignItems="center" textAlign="center" spacing={5}>
        <Image src={logo} w="50%" />
        <Text fontSize="lg" textShadow="10px 10px 4px rgba(0, 0, 0, 0.5)">
          {name}
        </Text>
        <Text
          fontWeight="400"
          pr={5}
          textShadow="10px 10px 4px rgba(0, 0, 0, 0.5)"
        >
          {position}
        </Text>
        <HStack>
          {/* <Image src={social1} w="30px" /> */}
          <a href={telegram}>
            <Image src={social3} w="30px" />
          </a>
          <a href={twitter}>
            <Image src={social2} w="30px" />
          </a>

          {/* <Image src={social4} w="30px" /> */}
          {/* <Image src={social5} w="30px" /> */}
        </HStack>
      </VStack>
    </Box>
  );
};

export default index;
